import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '@/layouts/Header';
import styles from './base.module.css';

const BaseLayout: React.FC = () => {
  return (
    <div className={styles.base}>
      <Header />
      <div className={styles.container}>
        <Outlet />
      </div>
    </div>
  );
};

export default BaseLayout;
